var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 462,
        visible: _vm.visible,
        footer: null
      },
      on: { cancel: _vm.handleCancel }
    },
    [
      _c("div", { staticClass: "product-detail-root" }, [
        _c("div", { staticClass: "product-swiper" }, [
          _vm.images && _vm.images.length > 0
            ? _c("img", {
                attrs: { width: "100%", height: "316", src: _vm.images[0] }
              })
            : _vm._e()
        ]),
        _c("div", { staticClass: "product-content" }, [
          _c(
            "div",
            { staticClass: "product-tags" },
            _vm._l(_vm.tags, function(i) {
              return _c("span", { key: i, staticClass: "product-tag" }, [
                _vm._v(_vm._s(i))
              ])
            }),
            0
          ),
          _c("div", { staticClass: "product-name" }, [
            _vm._v("\n        " + _vm._s(_vm.record.name) + "\n      ")
          ]),
          _c("div", { staticClass: "product-shop" }, [
            _vm._v("\n        " + _vm._s(_vm.record.businessName) + "\n      ")
          ]),
          _c("div", { staticClass: "product-field" }, [
            _c("div", { staticClass: "product-price" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "currentColor",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    size: "16",
                    color: "#D5A85F",
                    "data-v-5d0cdcb4": ""
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "ic-honhaimoney-red",
                        transform: "translate(0 0.296)"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          id: "Subtraction_9",
                          "data-name": "Subtraction 9",
                          d:
                            "M-2494,2102.7a8.009,8.009,0,0,1-8-8,8.009,8.009,0,0,1,8-8,8.009,8.009,0,0,1,8,8A8.009,8.009,0,0,1-2494,2102.7Zm-1.508-7.333h3.015v3.333h1.993v-8h-1.993v3.179h-3.015V2090.7h-1.992v8h1.992v-3.333Z",
                          transform: "translate(2502 -2087)"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v("\n          " + _vm._s(_vm.record.price) + "\n        ")
            ]),
            _c("div", { staticClass: "product-marketPrice" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M8 0C10.1209 0.00264619 12.1546 0.845985 13.6543 2.3457C15.1539 3.8454 15.9973 5.87915 16 8C15.9976 10.121 15.1541 12.1545 13.6543 13.6543C12.1545 15.1541 10.121 15.9976 8 16C5.87896 15.9979 3.84553 15.1541 2.3457 13.6543C0.845871 12.1545 0.00211791 10.1211 0 8C0.00239822 5.87902 0.845943 3.84546 2.3457 2.3457C3.84548 0.845947 5.87901 0.00238209 8 0ZM8.2998 3C7.75997 3.0001 7.3302 3.41786 7.33008 3.90527V4.10449H7.12988C5.95 4.10455 5.0001 5.01984 5 6.11426V6.67188C5.00013 7.76626 5.95002 8.68158 7.12988 8.68164H9.16992C9.43983 8.68164 9.64003 8.89038 9.66016 9.11914V9.13965C9.65998 9.41808 9.43981 9.62695 9.16992 9.62695H5.98047C5.44051 9.62695 5.00007 10.0447 5 10.5322C5 11.0197 5.42985 11.4374 5.96973 11.4375H7.32031V11.6367C7.32031 12.1243 7.73004 12.542 8.29004 12.542C8.85002 12.542 9.25977 12.1243 9.25977 11.6367V11.4375H9.45996C10.64 11.4375 11.5801 10.5223 11.5801 9.42773V8.89062C11.5801 7.79616 10.6301 6.88096 9.4502 6.88086H7.42969C7.16992 6.88069 6.94062 6.67171 6.94043 6.40332C6.94043 6.13477 7.15983 5.91521 7.42969 5.91504H10.6396C11.1796 5.91504 11.6104 5.49733 11.6104 5.00977C11.6102 4.52228 11.1796 4.10449 10.6396 4.10449H9.26953V3.90527C9.26941 3.4178 8.83973 3 8.2998 3Z",
                      fill: "#FFA47C"
                    }
                  })
                ]
              ),
              _vm._v(
                "\n          " +
                  _vm._s(
                    "市售價 $" +
                      (_vm.record.marketPrice ? _vm.record.marketPrice : "1000")
                  ) +
                  "\n        "
              )
            ]),
            _c("div", { staticClass: "product-stock" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "currentColor",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    size: "16",
                    color: "#0c52a7",
                    "data-v-27567401": ""
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "ic-honhaimoney",
                        transform: "translate(0 0.296)"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          id: "Subtraction_9",
                          "data-name": "Subtraction 9",
                          d:
                            "M-2494,2102.7a8.009,8.009,0,0,1-8-8,8.009,8.009,0,0,1,8-8,8.009,8.009,0,0,1,8,8A8.009,8.009,0,0,1-2494,2102.7Zm-4.1-9.448h0v3.394a.913.913,0,0,0,.456.788l2.958,1.691v-3.9l-3.415-1.975Zm8.194,0h0l-3.413,1.975v3.9l2.957-1.691a.914.914,0,0,0,.456-.788v-3.394Zm-4.1-2.975a.912.912,0,0,0-.455.121l-2.942,1.681,3.4,1.965,3.4-1.965-2.943-1.681A.914.914,0,0,0-2494,2090.281Z",
                          transform: "translate(2502 -2087)"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(
                "\n          " +
                  _vm._s(
                    "尚餘數量 " +
                      (_vm.record.balance ? _vm.record.balance : "1000") +
                      "组"
                  ) +
                  "\n        "
              )
            ])
          ]),
          _c("div", { staticClass: "product-driver" }),
          _c("div", { staticClass: "product-introduce" }, [
            _c("div", { staticClass: "product-tabs" }, [
              _vm.record.virtual === 0
                ? _c(
                    "h5",
                    {
                      staticClass: "product-introduce-title",
                      class: { active: _vm.active === 0 },
                      on: {
                        click: function($event) {
                          return _vm.showFlagChange(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s("產品介紹"))]
                  )
                : _vm._e(),
              _vm.record.virtual === 0
                ? _c("span", [_vm._v("       ")])
                : _vm._e(),
              _c(
                "h5",
                {
                  staticClass: "product-introduce-title",
                  class: { active: _vm.active === 1 },
                  on: {
                    click: function($event) {
                      return _vm.showFlagChange(1)
                    }
                  }
                },
                [_vm._v(_vm._s("商家故事") + "\n          ")]
              )
            ]),
            _vm.active === 0
              ? _c("div", [
                  _vm.record.description
                    ? _c("p", {
                        staticClass: "product-introduce-text",
                        domProps: {
                          innerHTML: _vm._s(_vm.record.description || "--")
                        }
                      })
                    : _vm._e(),
                  _vm.record.virtual == 0
                    ? _c("dl", { staticClass: "product-introduce-attr" }, [
                        _c("dt", { staticClass: "product-attr-label" }, [
                          _vm._v("內容物重量(g)")
                        ]),
                        _c("dd", {
                          staticClass: "product-attr-value",
                          domProps: {
                            innerHTML: _vm._s(_vm.record.weight || "--")
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm.record.virtual == 0
                    ? _c("dl", { staticClass: "product-introduce-attr" }, [
                        _c("dt", { staticClass: "product-attr-label" }, [
                          _vm._v("外盒尺寸長*寬*高 (cm)")
                        ]),
                        _c("dd", {
                          staticClass: "product-attr-value",
                          domProps: {
                            innerHTML: _vm._s(
                              (_vm.record.length || "--") +
                                "*" +
                                (_vm.record.width || "--") +
                                "*" +
                                (_vm.record.height || "--")
                            )
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm.record.virtual == 0
                    ? _c("dl", { staticClass: "product-introduce-attr" }, [
                        _c("dt", { staticClass: "product-attr-label" }, [
                          _vm._v("有效日期")
                        ]),
                        _c("dd", {
                          staticClass: "product-attr-value",
                          domProps: {
                            innerHTML: _vm._s(_vm.record.validityPeriod || "--")
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm.record.virtual == 0
                    ? _c("dl", { staticClass: "product-introduce-attr" }, [
                        _c("dt", { staticClass: "product-attr-label" }, [
                          _vm._v("成分")
                        ]),
                        _c("dd", {
                          staticClass: "product-attr-value",
                          domProps: {
                            innerHTML: _vm._s(_vm.record.ingredient || "--")
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm.record.virtual == 0
                    ? _c("dl", { staticClass: "product-introduce-attr" }, [
                        _c("dt", { staticClass: "product-attr-label" }, [
                          _vm._v("產地")
                        ]),
                        _c("dd", {
                          staticClass: "product-attr-value",
                          domProps: {
                            innerHTML: _vm._s(_vm.record.origin || "--")
                          }
                        })
                      ])
                    : _vm._e()
                ])
              : _c("div", { domProps: { innerHTML: _vm._s(_vm.record.story) } })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }